import { createSlice } from "@reduxjs/toolkit";

const initialIssuesStatusesState = "";

const extraIssueSlice = createSlice({
  name: "extraIssue",
  initialState: initialIssuesStatusesState,
  reducers: {
    setExtraIssuesData: (_state, action) => action.payload,
  },
});

export const { setExtraIssuesData } = extraIssueSlice.actions;

export const extraIssue = extraIssueSlice.reducer;

export default extraIssueSlice.reducer;
